<template>
	<b-modal
		id="skillformmodal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		v-model="showModal"
		@hidden="$emit('close-modal')"
	>
		<main class="d-flex w-100">
			<section class="candash-modal-left width-5"></section>
			<section class="w95">
				<header class="candash-modal-top p-3">
					<div class="width-97 ml-1">
						<div class="candash-modal-head">Skills</div>
						<div class="candash-desc">Fill your skills</div>
					</div>
					<div class="d-flex justify-content-end pointer">
						<img
							@click="$emit('close-modal')"
							class="rotate-on-hover"
							src="../../assets/newdesign/dashboard/blueCross.svg"
							alt=""
						/>
					</div>
				</header>
				<SkillForm
					@cancel="$emit('close-modal')"
					@data-added="$emit('data-added')"
					@close-modal="$emit('close-modal')"
					@show-success="showSuccess"
					:singleData="singleData"
					:formType="formType"
				/>
			</section>
		</main>
	</b-modal>
</template>

<script>
import SkillForm from "./SkillForm.vue";

export default {
	name: "SkillModal",
	components: {
		SkillForm,
	},
	props: {
		showModal: Boolean,
		singleData: Object,
		formType: String,
	},
	methods: {
		showSuccess(event) {
			this.$emit("show-success", event);
		},
	},
};
</script>

<style></style>
